import Vue from 'vue';
import FeaturesList from './components/features-list/FeaturesList.vue';

$(function () {
    $('.legacy-layout .features-block.list').each(function () {
        new Vue({
            el: this,
            components: {FeaturesList}
        })
    });
});
